export default {
    data() {
        return {
            // 角色
            mappingRole: [
                // {
                //   text: "開發者",
                //   value: 100
                // },
                {
                    text: "最高管理者",
                    value: 200
                },
                {
                    text: "加盟者",
                    value: 300
                },
                {
                    text: "客服",
                    value: 400
                }
            ],
            // 帳號狀態
            mappingStatus: [
                {
                    text: "啟用",
                    value: "active"
                },
                {
                    text: "停用",
                    value: "disable"
                }
            ],

            // 瀏覽資料狀態
            viewStatus: [
                {
                    text: "可瀏覽現金交易資料",
                    value: 1
                },
                {
                    text: "不可瀏覽現金交易資料",
                    value: 0
                }
            ],

            // 優惠方案狀態
            mappingAvailable: [
                {
                    text: "啟用",
                    value: true
                },
                {
                    text: "停用",
                    value: false
                }
            ],

            // 優惠方案狀態
            weekdayTypes: [
                {text: "全時段使用",value: 0},
                {text: "優惠時段專用",value: 1},
            ],
            
            //機器類型
            machineTypeList: [
                {
                    text : '所有類型',
                    value : '',
                },
                {
                    text : 'CCB',
                    value : 'CCB',
                },
                {
                    text : 'CCA',
                    value : 'CCA',
                },
                {
                    text : 'MU',
                    value : 'MU',
                },
            ],
        }
    }
}
